<template>
  <div class="dynamic-content">
    <h1 class="page-title">Legal Information & Notices</h1>

    <p class="desc-text section-spacing">This section contains important legal information related to your use of XigFor.</p>

    <div class="bottom-links">
      <div class="link-item">
        <router-link to="/terms-of-service" class="action-link">Terms of Service</router-link>
        <span class="arrow-icon">></span>
      </div>
      <div class="link-item">
        <router-link to="/content/platform-disclaimer" class="action-link">Platform Disclaimer</router-link>
        <span class="arrow-icon">></span>
      </div>
      <div class="link-item">
        <router-link to="/content/intellectual-property" class="action-link">Intellectual Property Policy</router-link>
        <span class="arrow-icon">></span>
      </div>
      <div class="link-item">
        <router-link to="/content/smartrewards-terms" class="action-link">SmartRewards Terms & Conditions</router-link>
        <span class="arrow-icon">></span>
      </div>
      <div class="link-item">
        <router-link to="/privacy-policy" class="action-link">Privacy Policy</router-link>
        <span class="arrow-icon">></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalNotices'
}
</script>

<style scoped>
@import './shared-info-styles.css';
</style>
